export default __webpack_public_path__ + "static/media/login-ad@2x.8fcb3a96.png";